import React from 'react';

export const Title = ({ Class, Name }) => <h4 className={Class}>{Name}</h4>;
export const Subtitle = ({ Class, Name }) => <h5 className={Class}>{Name}</h5>;
export const Description = ({ Class, Name }) => <p className={Class}>{Name}</p>;

export const Titlespan = ({ Class, Label, Name }) => (
  <h2 className={Class}><span className="label">{Label}</span> {Name}</h2>
);

export const Titlespan2 = ({ Class, Label, Name }) => (
  <h2 className={Class}>{Name} <span className="label1">{Label}</span></h2>
);
